import { AsyncPipe, NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import {
  BreakpointObserver,
  LayoutModule as CdkLayout,
} from '@angular/cdk/layout';
import { MatDrawerMode, MatSidenavModule } from '@angular/material/sidenav';
import { Observable, map } from 'rxjs';
import { BREAKPOINTS } from '../models/layout-breakpoints';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'edt-layout-base',
  standalone: true,
  templateUrl: './base-layout.component.html',
  styleUrls: ['./base-layout.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgStyle, MatSidenavModule, CdkLayout, AsyncPipe],
})
export class BaseLayoutComponent {
  isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(BREAKPOINTS.md)
    .pipe(
      takeUntilDestroyed(),
      map((result) => result.matches)
    );

  @Input() sideNavMode: MatDrawerMode = 'over';
  @Input({ required: true }) alwaysShowToggle = false;
  @Input({ required: true }) footerTheme: { [style: string]: string } = {
    height: '24px',
    'background-color': 'blue',
  };
  @Input({ required: true }) containerTheme: { [style: string]: string } = {};

  constructor(private breakpointObserver: BreakpointObserver) {}
}
